/**
 * Timekeeper actions
 */

import UPDATE_TIME from './constants';

export default function updateTime(time: string) {
    return {
        type: UPDATE_TIME,
        payload: {
            time
        }
    };
}
